import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function CardTickIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.625 4.04867C18.4214 4.01671 18.2126 4.00012 18 4.00012H6C3.79086 4.00012 2 5.79098 2 8.00012V16.0001C2 18.2093 3.79086 20.0001 6 20.0001H18C20.2091 20.0001 22 18.2093 22 16.0001V8.00012C22 7.73992 21.6932 7.63534 21.5092 7.81933L19.938 9.39053C19.1762 10.1524 17.9477 10.1738 17.1598 9.43897L15.6359 8.01789C14.8281 7.26454 14.784 5.99898 15.5373 5.19118C16.2907 4.38338 17.5562 4.33923 18.3641 5.09257C18.4261 5.15047 18.5229 5.14878 18.5829 5.08876L18.836 4.83567C19.1072 4.56447 19.0039 4.10813 18.625 4.04867ZM5.2501 15.0001C5.2501 14.5859 5.58588 14.2501 6.0001 14.2501H7.0001C7.41431 14.2501 7.7501 14.5859 7.7501 15.0001C7.7501 15.4143 7.41431 15.7501 7.0001 15.7501H6.0001C5.58588 15.7501 5.2501 15.4143 5.2501 15.0001ZM10.0001 14.2501C9.58588 14.2501 9.2501 14.5859 9.2501 15.0001C9.2501 15.4143 9.58588 15.7501 10.0001 15.7501H11.0001C11.4143 15.7501 11.7501 15.4143 11.7501 15.0001C11.7501 14.5859 11.4143 14.2501 11.0001 14.2501H10.0001ZM13.2501 15.0001C13.2501 14.5859 13.5859 14.2501 14.0001 14.2501H18.0001C18.4143 14.2501 18.7501 14.5859 18.7501 15.0001C18.7501 15.4143 18.4143 15.7501 18.0001 15.7501H14.0001C13.5859 15.7501 13.2501 15.4143 13.2501 15.0001Z"
        fill="currentColor"
      />
      <path
        d="M22.0303 5.53045C22.3232 5.23756 22.3232 4.76269 22.0303 4.46979C21.7374 4.1769 21.2626 4.1769 20.9697 4.46979L18.5056 6.93383L17.5115 6.00673C17.2086 5.72423 16.734 5.74079 16.4515 6.04371C16.169 6.34664 16.1856 6.82122 16.4885 7.10373L18.0123 8.52481C18.3078 8.80037 18.7684 8.79234 19.0541 8.50664L22.0303 5.53045Z"
        fill="currentColor"
      />
    </svg>
  )
}
